module.exports = __webpack_public_path__ + "static/sample-10-739f2a0d5a80a8bd49dd173a977f0616.png";